require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-principal-components-analysis.json") })
        }
      }, "path---posts-principal-components-analysis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-principal-components-analysis!./.cache/json/posts-principal-components-analysis.json
// module id = 404
// module chunks = 231608221292675